import { Outlet, Link, useLocation } from "react-router-dom";
import { Compass, Calendar, MessageCircle, User } from "lucide-react";
import { useT } from "../lib/useLanguage";

const TABS = [
  { path: "/discover", icon: Compass, tkey: "nav_discover" },
  { path: "/sessions", icon: Calendar, tkey: "nav_sessions" },
  { path: "/messages", icon: MessageCircle, tkey: "nav_messages" },
  { path: "/profile", icon: User, tkey: "nav_profile" },
];

export default function Layout() {
  const { pathname } = useLocation();
  const t = useT();

  return (
    <div className="min-h-screen pb-20" style={{ backgroundColor: "#FFF4E8" }}>
      <Outlet />
      <nav className="fixed bottom-0 left-0 right-0 z-50 border-t" style={{ backgroundColor: "white", borderColor: "#f0ebe3" }}>
        <div className="max-w-lg mx-auto flex">
          {TABS.map(tab => {
            const active = pathname.startsWith(tab.path);
            return (
              <Link key={tab.path} to={tab.path}
                className="flex-1 flex flex-col items-center py-2.5 gap-0.5 text-xs font-semibold transition-colors"
                style={{ color: active ? "#FF6B4A" : "#9ca3af" }}>
                <tab.icon className="h-5 w-5" />
                {t(tab.tkey)}
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}